import { PROJECTS_VERSIONS_QUERY_PARAMS } from '@atlassian/jira-common-constants/src/projects-versions-query-params.tsx';
import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectVersionsRoute: InvariantJiraRoute = {
	name: 'project-versions',
	path: '/projects/:projectKey',
	query: PROJECTS_VERSIONS_QUERY_PARAMS,
};
